import { parseContentDispositionFilename, triggerBlobDownload } from '@/utils/blobDownload';
import apiClient from './api';
import type { AdminAlertsFilters, AdminAlertsPage } from '@/types/adminAlerts.types';

export async function listAdminAlerts(filters: AdminAlertsFilters): Promise<AdminAlertsPage> {
  const params: Record<string, string | number> = {};
  if (filters.tenantCode) params.tenant_code = filters.tenantCode;
  if (filters.startDate) params.start_date = filters.startDate;
  if (filters.endDate) params.end_date = filters.endDate;
  if (filters.riskLevel) params.risk_level = filters.riskLevel;
  if (filters.limit !== undefined) params.limit = filters.limit;
  if (filters.offset !== undefined) params.offset = filters.offset;
  const response = await apiClient.get<AdminAlertsPage>('/api/admin/alerts', { params });
  return response.data;
}

async function downloadAlertReport(path: string, alertId: string): Promise<void> {
  const response = await apiClient.get<Blob>(path, { responseType: 'blob' });
  const filename = parseContentDispositionFilename(
    response.headers['content-disposition'],
    `alert-${alertId}.pdf`
  );
  triggerBlobDownload(response.data, filename);
}

export function downloadAdminAlertReport(alertId: string): Promise<void> {
  return downloadAlertReport(
    `/api/admin/alerts/${encodeURIComponent(alertId)}/report.pdf`,
    alertId
  );
}

export function downloadTenantAlertReport(alertId: string): Promise<void> {
  return downloadAlertReport(
    `/api/tenant/alerts/${encodeURIComponent(alertId)}/report.pdf`,
    alertId
  );
}
